/* eslint-disable no-lonely-if */
import { useState, useEffect } from 'react'
import { helper } from 'newFunctions/multipleFunctions'
import { useFirstRender } from 'hooks';

export function useAlgoliaHelper(props = false){
    const {
        type = 'search'
    } = props


    const [ data , setData ] = useState()
    const [ hits, setHits ] = useState([])
    const [ queryID, setQueryID ] = useState()
    const [ totalHits, setTotalHits ] = useState()
    const [ facets, setFacets ] = useState([])
    const [ currentPage, setCurrentPage ] = useState(0)
    const [ totalPages, setTotalPages ] = useState(0)
    const [ categoryFilter, setCategoryFilter ] = useState()
    const [ catPre, setCatPre ] = useState()
    const [ searchPre, setSearchPre ] = useState()
    const [ firstCategory, setFirstCategory ] = useState()
    const isFirstRender = useFirstRender();

    // Función para agregar analyticsTags
    function addAnalyticsTags(tags) {
        const existingTags = [];
        const newTags = existingTags.concat(tags);
        // console.log('analyticsTags: ',newTags)
        helper.setQueryParameter('analyticsTags', newTags);
    }


    const startSearch = (searchParams, page) => {

        if(searchParams){
            helper.clearRefinements();
            if(type === 'category'){
                if(searchParams?.toLowerCase()){
                    setCatPre(searchParams?.toLowerCase())
                    setFirstCategory(searchParams?.toLowerCase())
                    // helper.setQueryParameter('analyticsTags', ['alg#']);
                    addAnalyticsTags(['web', 'mesa_regalos', 'categoria'])
                    helper.toggleFacetRefinement('hirerarchical_category', searchParams?.toLowerCase()).search()
                }
            }
            else{
                addAnalyticsTags(['web', 'mesa_regalos', 'buscador'])
                helper.setQuery(searchParams).search()
            }
        }
        if(page){
            addAnalyticsTags(['web', 'mesa_regalos', 'paginacion'])
            helper.setPage(page).search()
        }
    }

    const handleSearchChange = (value) => {
        if(value){
            helper.clearRefinements((attribute) => attribute !== 'query');
            if(type !== 'category'){
                setSearchPre(value)
                addAnalyticsTags(['web', 'mesa_regalos', 'buscador'])
                helper.setQuery(value).search();
            }else{
                helper.toggleFacetRefinement( 'hirerarchical_category', value?.toLowerCase() ).search()
                setCatPre(value?.toLowerCase())
                addAnalyticsTags(['web', 'mesa_regalos', 'categoria'])
                setFirstCategory(value?.toLowerCase())
            }
        }
    }
    const handleChangeIndex = (newIndex) => {
        if(newIndex){
            addAnalyticsTags(['web', 'mesa_regalos', 'orden'])
            helper.setIndex(newIndex).search();
        }
    };
    const handleChangePage = (page) => {
        if(page){
            addAnalyticsTags(['web', 'mesa_regalos', 'paginacion'])
            helper.setPage(page).search();
        }
    };


    const handleChangeFilters = (filters) => {
        if(filters){
            if(filters?.length >= 1){
                if(type !== 'category'){
                    addAnalyticsTags(['web', 'mesa_regalos', 'buscador'])
                    helper.clearRefinements((attribute) => attribute !== 'query');
                }
                else{
                    addAnalyticsTags(['web', 'mesa_regalos', 'categoria'])
                    helper.clearRefinements((attribute) =>  attribute !== catPre);
                }
                filters.map(perFilter => {
                    if(perFilter?.review_rating){
                        // console.log('review_rating: ',perFilter?.review_rating)
                        helper.toggleFacetRefinement('review_rating', perFilter?.review_rating)
                    }
                    if(perFilter?.has_free_shipping){
                        // console.log('has_free_shipping: ',perFilter?.has_free_shipping)
                        helper.toggleFacetRefinement('has_free_shipping', perFilter?.has_free_shipping)
                    }
                    if(perFilter?.fulfillment){
                        // console.log('fulfillment: ',perFilter?.fulfillment)
                        helper.toggleFacetRefinement('fulfillment', perFilter?.fulfillment)
                    }
                    if(perFilter?.brand){
                        perFilter?.brand.map(brandList => {
                            // console.log('brand: ', brandList?.brand)
                            helper.toggleFacetRefinement('brand', brandList?.brand)
                            return brandList
                        })
                    }
                    if(perFilter?.percent_off){
                        // console.log('percent_off: ',perFilter?.percent_off)
                        helper.addNumericRefinement('percent_off', '>=', perFilter?.percent_off?.min)
                        helper.addNumericRefinement('percent_off', '<=', perFilter?.percent_off?.max)
                    }
                    if(perFilter?.sale_price){
                        // console.log('sale_price: ',perFilter?.sale_price)
                        helper.addNumericRefinement('sale_price', '>=', perFilter?.sale_price?.min)
                        helper.addNumericRefinement('sale_price', '<=', perFilter?.sale_price?.max)
                    }
                    if(perFilter?.hirerarchical_category){
                        // console.log('hirerarchical_category: ',perFilter?.hirerarchical_category)
                        helper.toggleFacetRefinement('hirerarchical_category', perFilter?.hirerarchical_category)
                        setCatPre(perFilter?.hirerarchical_category)
                    }
                    if(perFilter?.review_rating || perFilter?.has_free_shipping || perFilter?.fulfillment || perFilter?.brand || perFilter?.percent_off || perFilter?.sale_price || perFilter?.hirerarchical_category){
                        addAnalyticsTags(['web', 'mesa_regalos', 'filtros'])
                        helper.search()
                    }
                    return true
                })
                
            }else{
                if(type === 'category'){
                    addAnalyticsTags(['web', 'mesa_regalos', 'categoria'])
                    helper.clearRefinements((attribute) =>  attribute !== catPre);
                    helper.toggleFacetRefinement('hirerarchical_category', firstCategory).search()
                }
                else if(type === 'search'){
                    addAnalyticsTags(['web', 'mesa_regalos', 'buscador'])
                    helper.clearRefinements();
                    helper.setQuery(searchPre).search()
                }
                else{
                    helper.search()
                }
            }
        }
    };

    useEffect(() => {
        if(isFirstRender){
            helper.on('result', searchResults => {
                setData(searchResults)
                setHits(searchResults?.results?.hits)
            })
        }
    }, [ isFirstRender ])

    useEffect(() => {
        if(data){
            setQueryID(data?.results?.queryID)
            setTotalHits(data?.results?.nbHits)
            setFacets(data?.results?.disjunctiveFacets)
            setCurrentPage(data?.results?.page)
            setTotalPages(data?.results?.nbPages)
            setCategoryFilter(data?.results?.hierarchicalFacets[0]?.data)
            // console.log('data: ',data?.results)
        }
    }, [ data ])

    return {
        hits,
        data,
        queryID,
        totalHits,
        facets,
        categoryFilter,
        currentPage,
        totalPages,
        startSearch,
        handleSearchChange,
        handleChangeIndex,
        handleChangePage,
        handleChangeFilters
    }
}